var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinIconH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.76 13.76",
    height: 13.76,
    width: 13.76,
    id: "svg32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs36"
  })), /*#__PURE__*/React.createElement("image", {
    y: 0,
    x: 0,
    id: "image40",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA pklEQVRYw+3ZLQ4CMRCG4bcbFOvXg99T7FG4BafAw1VALx7dWyy2mIoGgSOZJu/n6p70ZybppFIK vWSgo4gVK1asWLFixYoVK1asWLFixYoV+yO7r/UMHIAxiO8FZGBrsUfgDEwBN/QNXIA11S/PW1Bo Cz4N9ein4Nd1Dyw9PbDR0iVW7J+xudax6HkOtZVdg0MfQE7N0G4GlmANYgNW4A6QepowfgDMXB26 b1V6LAAAAABJRU5ErkJggg== ",
    style: {
      imageRendering: "optimizeQuality"
    },
    preserveAspectRatio: "none",
    height: 13.76,
    width: 13.76
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinIconH);
export default __webpack_public_path__ + "static/media/min_icon_h.3d9cf2a5df3ac8577fc4a3bfe1545dd2.svg";
export { ForwardRef as ReactComponent };